exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".AccountSettingsSideMenu-listContainer-3VAbh {\n  padding-left: 0px;\n  list-style-type: none;\n}\n.AccountSettingsSideMenu-sideNavitem-hFcOX{\n  display: block;\n  padding: 8px 0;\n  font-size: 16px;\n  color: #767676;\n  text-decoration: none !important;\n}", "", {"version":3,"sources":["/root/bettertrip-web-app/src/components/AccountSettingsSideMenu/AccountSettingsSideMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,sBAAsB;CACvB;AACD;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;CAClC","file":"AccountSettingsSideMenu.css","sourcesContent":[".listContainer {\n  padding-left: 0px;\n  list-style-type: none;\n}\n.sideNavitem{\n  display: block;\n  padding: 8px 0;\n  font-size: 16px;\n  color: #767676;\n  text-decoration: none !important;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"listContainer": "AccountSettingsSideMenu-listContainer-3VAbh",
	"sideNavitem": "AccountSettingsSideMenu-sideNavitem-hFcOX"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":true,"modules":true,"localIdentName":"[name]-[local]-[hash:base64:5]","minimize":false,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/AccountSettingsSideMenu/AccountSettingsSideMenu.css
// module id = 2576
// module chunks = 8